import { Component, Prop, Vue } from 'vue-property-decorator'

import DateInputCombo from '@/components/DateInputCombo/index.vue'
import RatingDeadlineCard from './RatingDeadlineCard/index.vue'
import Loader from '@/components/Loader/index.vue'

import vSelect from 'vue-select'

import api from '@/helpers/fetch'
import tableHelper from '@/helpers/table'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faChevronRight,
	faChevronLeft,
} from '@fortawesome/free-solid-svg-icons'

library.add(faChevronRight, faChevronLeft)
@Component({
	components: {
		vSelect,
		DateInputCombo,
		RatingDeadlineCard,
		Loader,
	},
})
export default class RatingDeadlines extends Vue {
	ratings = [] as any[]
	loading = true

	form = {
		rating: '',
		begin_date: '',
		end_date: '',
		responsible: [],
		difficulty: '',
		delay: [],
	}

	counting = {
		Insatisfatório: 0,
		Regular: 0,
		Bom: 0,
		Ótimo: 0,
		Excelente: 0,
		total: 0,
		difficulty: {
			Fácil: 0,
			Médio: 0,
			Difícil: 0,
		},
	}

	avg = {
		punctuality_team: 0,
		punctuality_personal: 0,
	}

	itemsPerPage = 20
	currentPage = 1
	showResponsible = false

	options = {
		rating: ['Excelente', 'Ótimo', 'Bom', 'Regular', 'Insatisfatório'],
		responsibleUsers: [],
		difficulty: ['Difícil', 'Médio', 'Fácil'],
		delay: ['N/A', 'Interno', 'Externo'],
	}

	async mounted() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
		await this.loadUserRoles()
		await this.loadRatings()
	}

	async loadRatings() {
		this.loading = true
		await this.loadCounting()
		await this.loadAvg()
		const res = await api.get(
			'/api/ratings/deadlines?' + this.getQueryUrl(),
		)

		if (res.ok) {
			this.ratings = res.data.map((rating) => {
				// formata data de entrega
				if (rating.deadline_providence.deadline.deliveredDate) {
					const [year, month, day] =
						rating.deadline_providence.deadline.deliveredDate.split(
							'-',
						)
					rating.deadline_providence.deadline.deliveredDate = `${day}/${month}/${year}`
				}

				// formata data da ultima atualização
				rating.updated_at = new Date(
					rating.updated_at,
				).toLocaleDateString()

				return rating
			})
		}
		this.loading = false
	}

	async loadAvg() {
		const res = await api.get(
			'/api/deadline-manager/collections/avg/punctuality?' +
				this.getQueryUrl(),
		)

		if (res.ok) {
			res.data.punctuality_team = res.data.punctuality_team
				? res.data.punctuality_team
				: 0
			this.avg.punctuality_team = parseFloat(
				res.data.punctuality_team.toFixed(2),
			)

			res.data.punctuality_personal = res.data.punctuality_personal
				? res.data.punctuality_personal
				: 0
			this.avg.punctuality_personal = parseFloat(
				res.data.punctuality_personal.toFixed(2),
			)
		}
	}

	async loadUserRoles() {
		const res = await api.get('/api/my-account/permissions/roles')

		if (res.ok) {
			// apenas gestores ou admin podem usar o filtro "responsavel"
			// caso contrario o campo ficara travado no usuario logado
			if (
				res.data.find(
					(roles) => roles === 'gestores' || roles === 'admin',
				)
			) {
				this.showResponsible = true
				await this.loadResponsibleUsers()
			}
		}
	}

	async loadResponsibleUsers() {
		const res = await api.get('/api/users/by/deadline/responsible')

		if (res.ok) {
			this.options.responsibleUsers = res.data
		}
	}

	async loadCounting() {
		const res = await api.get(
			'/api/ratings/deadlines/count?' + this.getQueryUrl(),
		)

		if (res.ok) {
			this.counting['Insatisfatório'] =
				res.data.insatisfatorio?.aggregate.count || 0
			this.counting.Regular = res.data.regular?.aggregate.count || 0
			this.counting.Bom = res.data.bom?.aggregate.count || 0
			this.counting['Ótimo'] = res.data.otimo?.aggregate.count || 0
			this.counting.Excelente = res.data.excelente?.aggregate.count || 0
			this.counting.total = res.data.all?.aggregate.count || 0
		}

		if (this.form.rating) {
			this.counting.total = this.counting[this.form.rating]
		}

		this.counting.difficulty['Fácil'] = 0
		this.counting.difficulty['Médio'] = 0
		this.counting.difficulty['Difícil'] = 0

		if (this.form.difficulty) {
			await this.countDifficulty(this.form.difficulty)
		} else {
			await this.countDifficulty('Fácil')
			await this.countDifficulty('Médio')
			await this.countDifficulty('Difícil')
		}
	}

	async countDifficulty(difficulty) {
		const res = await api.get(
			'/api/ratings/deadlines/count?' +
				this.getQueryUrl(true) +
				'&difficulty=' +
				difficulty,
		)
		const transform = {
			Insatisfatório: 'insatisfatorio',
			Regular: 'regular',
			Bom: 'bom',
			Ótimo: 'otimo',
			Excelente: 'excelente',
		}

		if (res.ok) {
			if (this.form.rating) {
				this.counting.difficulty[difficulty] =
					res.data[transform[this.form.rating]].aggregate.count
			} else {
				this.counting.difficulty[difficulty] =
					res.data.all?.aggregate.count
			}
		}
	}

	clearForm() {
		this.form.rating = ''
		this.form.begin_date = ''
		this.form.end_date = ''
		this.form.responsible = []
		this.form.difficulty = ''
		this.form.delay = []
	}

	getPercent(qtd) {
		return this.counting.total === 0
			? 0
			: parseFloat(((100 * qtd) / this.counting.total).toFixed(2))
	}

	formatDate(date) {
		const [day, month, year] = date.split('/')
		return [year, month, day].join('-')
	}

	getQueryUrl(isCountURL = false) {
		const query = [] as any[]
		if (this.form.rating) {
			query.push('rating=' + this.form.rating)
		}

		if (this.form.begin_date) {
			query.push('begin_date=' + this.formatDate(this.form.begin_date))
		}

		if (this.form.end_date) {
			query.push('end_date=' + this.formatDate(this.form.end_date))
		}

		if (this.form.responsible.length > 0) {
			query.push('responsible=' + this.form.responsible)
		}

		if (this.form.delay.length > 0) {
			query.push('delay=' + this.form.delay)
		}

		// quando for gerar query para endpoint count nao add essa var
		if (this.form.difficulty && !isCountURL) {
			query.push('difficulty=' + this.form.difficulty)
		}

		query.push('items=' + this.itemsPerPage)
		query.push('page=' + this.currentPage)

		return query.join('&')
	}

	get totalPages() {
		return Math.ceil(this.counting.total / this.itemsPerPage)
	}

	async nextPage() {
		if (this.currentPage + 1 > this.totalPages) return
		this.currentPage++
		await this.loadRatings()
	}

	async prevPage() {
		if (this.currentPage - 1 < 0) return
		this.currentPage--
		await this.loadRatings()
	}
}
